<template>
  <div class="pd-x-20 pd-y-10">
    <div v-if="!fetched">
      түр хүлээнэ үү...
    </div>
    <div v-else>
      <div v-if="tasksCount > 0">
        <div class="row row-xs">
          <div class="col-sm-4 col-md-3 col-lg-4 col-xl-3 mg-t-10 mg-sm-t-0">
            <div class="card card-profile" v-for="(t, i) in tasks" :key="i">
              <img :src="t.defaultAttachmentUrl" class="card-img-top" alt="" />
              <div class="card-body tx-13">
                <div>
                  <a href="">
                    <div class="avatar avatar-lg">
                      <span class="avatar-initial rounded-circle bg-gray-300"
                        >c</span
                      >
                    </div>
                  </a>
                  <h5>
                    <a href="">{{ t.task }}</a>
                  </h5>
                  <p>Тайлбар</p>
                  <button class="btn btn-block btn-white">Дэлгэрэнгүй</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>empty here with editable</div>
    </div>
  </div>
</template>

<script>
import { coreBoxInTaskList } from "@/api/taskCore";
export default {
  props: {
    parentTask: {
      type: Object,
      default: () => {}
    },
    box: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      fetched: false,
      tasks: [],
      tasksCount: 0
    };
  },
  methods: {
    init() {
      coreBoxInTaskList({
        data: {
          id: this.box.id,
          skip: 0,
          size: 100
        },
        store: this.$store
      }).then(res => {
        //console.log(res);
        this.fetched = true;
        this.tasks = res.data.tasks;
        this.tasksCount = res.data.tasksCount;
      });
    }
  }
};
</script>

<style></style>
